import { ESRI } from '../../constants/mapProviders';

/**
 * Hide a marker instance based on the map provider
 * @param {Object} mapObject - map object
 * @param {Instance} marker - instance of the marker
 */
const hideMarker = (mapObject, marker) => {
  switch (mapObject.mapProvider) {
    case ESRI: {
      marker.graphic.visible = false;
      break;
    }
  }
};

export default hideMarker;
